import { render } from "./admin-openapi-doc.vue?vue&type=template&id=5b622d79&scoped=true"
import script from "./admin-openapi-doc.vue?vue&type=script&lang=js"
export * from "./admin-openapi-doc.vue?vue&type=script&lang=js"

import "./admin-openapi-doc.vue?vue&type=style&index=0&id=5b622d79&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b622d79"]])

export default __exports__